export const debounce = (
  func: (...args: unknown[]) => unknown,
  delay: number
) => {
  let timer: NodeJS.Timeout;
  return function (...args: unknown[]) {
    clearTimeout(timer);
    timer = setTimeout(() => func(...args), delay);
  };
};
